var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_nav_arrow-left",
    clipPath: "url(#clip0_2372_855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 2630",
    d: "M35.7667 19.7333H1.23333C0.542667 19.7333 0 19.1906 0 18.4999C0 17.8093 0.542667 17.2666 1.23333 17.2666H35.7667C36.4573 17.2666 37 17.8093 37 18.4999C37 19.1906 36.4573 19.7333 35.7667 19.7333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2631",
    d: "M18.5 37C18.1793 37 17.8587 36.8766 17.6367 36.63L0.37 19.3633C-0.123333 18.87 -0.123333 18.1053 0.37 17.612L17.6367 0.345302C18.13 -0.123365 18.8947 -0.123365 19.388 0.369969C19.8567 0.838636 19.8567 1.6033 19.388 2.09664L2.98467 18.5L19.388 34.9033C19.8813 35.3966 19.8813 36.1613 19.388 36.6546C19.166 36.8766 18.8453 37.0246 18.5247 37.0246L18.5 37Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2372_855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.0bc1552643d12650bd21a9866ad3c943.svg";
export { ForwardRef as ReactComponent };